import { globalDeleteService, globalGetService, globalExportService, globalPostService, globalFileUploadService, globalPutService, } from "../../../utils/globalApiServices";
import { downloadFileType, permissionCheckFnforCamo, } from "../../../utils";
import { trackActivity } from "../../../utils/mixpanel";
import { checkApiStatus } from "../../../utils";
import { assetType} from '../../../constants';
import moment from "moment";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
let timeoutId;

export async function getOpHistoryApi(queryParams = {}, loaderType, props = {}, searchString = null) {
    if (permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "R", })) {
        this.setState({ pageLoader: true });
        const { asset, assetType } = props?.match?.params;
        try {
            const response = await globalGetService('camo/ope_hist/', {
                ...queryParams,
                per_page: queryParams.per_page ? queryParams?.per_page : 50,
                asset: asset,
                asset_type: assetType,
                search: searchString,
            });

            if (response?.status === 500) {
                props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
                return null;
            } else {
                this.setState({
                    pageLoader: false,
                    assetsDetail: {
                        list: response?.data?.results,
                    },
                });
                delete queryParams.page;
                delete queryParams?.per_page;
                delete queryParams.asset_type;
                delete queryParams.sort;
                delete queryParams.sort_by;
                this.setState((prevState) => ({
                    ...prevState,
                    filter: queryParams,
                    assetsDetail: {
                        ...prevState.assetsDetail,
                        pagination: {
                            ...prevState.assetsDetail?.pagination,
                            total: response?.data?.pagination?.total,
                            per_page: response?.data?.pagination?.per_page,
                            page: parseInt(response?.data?.pagination?.current_page),
                        },
                        new_task_last_used_folder_uuid: response?.data?.new_task_last_used_folder_uuid,
                        last_used_folder_uuid_link_document: response?.data?.last_used_folder_uuid_link_document,
                        checkbox_last_used_folder_uuid: response?.data?.checkbox_last_used_folder_uuid,
                        checkbox_last_used_folder_name: response?.data?.checkbox_last_used_folder_name
                    },
                }));
                return response;
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            return null;
        }
    }
}

export function deleteOpAssetDetailRow(item, props, per_page) {
    globalDeleteService(`camo/ope_hist/${item.id}/`).then((response) => {
        if (response.status === 200) {
            props.enqueueSnackbar("Record Deleted Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, });
            trackActivity("OP History Deleted  Success - CAMO", {
                event_type: 'Deleted  Success',
                page_title: "OP History",
            });
        }
        if (response.status === 500) {
            props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
            trackActivity("OP History Deleted  Failed - CAMO", {
                event_type: 'Deleted  Failed',
                page_title: "OP History",
            });
        }
        this.getOpHistoryApi({ per_page: per_page }, "skeletonLoader", props);
    });
}

export function addOpFormApi(data, props,close) {
    if (permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C", })) {
        return new Promise(function (resolve, reject) {
            globalPostService(`camo/ope_hist/`, data).then((response) => {
                if (response?.data?.statusCode === 500 || response.data?.statusCode === 500) {
                    props.enqueueSnackbar( response.data?.statusCode === 500 ? response.data?.message :"Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
                    close()
                } else {
                    resolve(response);
                }
            });
        });
    }
}

export function fillOpEditFormApi(item, props) {
    return new Promise(function (resolve, reject) {
        globalGetService(`camo/ope_hist/${item.id}/`).then((response) => {
            if (response.status === 500) {
                props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
            } else {
                resolve(response);
            }
        });
    });
}

export function UpdateOpFormApi(updateId, updatedData, props, per_page,close,formClose) {
    if (permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U", })) {
        globalPutService(`camo/ope_hist/${updateId}/`, updatedData).then(
            (response) => {
                if (response?.data?.statusCode === 500 || response.data?.statusCode === 500) {
                    props.enqueueSnackbar( response.data?.statusCode === 500 ? response.data?.message :"Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
                    close()
                } else {
                    if (response) {
                        props.enqueueSnackbar("Record Updated Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, });
                        formClose()
                    }
                    this.getOpHistoryApi({ per_page: per_page }, "skeletonLoader", props);
                }
            }
        );
    }
}

export function uploadOpFileApi(uploadId, formdata, props, per_page, haveAttachments) {
    this.setState({ pageLoader: true });
    if (haveAttachments) {
        globalFileUploadService(`camo/attachment/upload/`, formdata)
            .then((response) => {
                if (response.status === 500) {
                    props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
                } else {
                    if (response?.data?.statusCode === 200) {
                        this.setState({ pageLoader: false });
                        if (response.data.data.length > 0) {
                        }
                    }
                    this.getOpHistoryApi({ per_page: per_page }, "skeletonLoader", props);
                }
            })
            .catch((err) => {
                console.error(err);
            });
    } else {
        props.enqueueSnackbar("Data Submitted Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, });
        this.getOpHistoryApi({ per_page: per_page }, "", props);
    }
}

export function exportOpListApi(queryParams = {}, loaderType, props = {}, basicDetails) {
    this.setState({ pageLoader: true });
    const date = new Date();
    const todayeDate = moment(String(date)).format("YYYY-MM-DD");

    const { asset, assetType } = this.props.match.params;
    delete queryParams.asset_type;
    globalExportService(assetType == 2 ? `/camo/ope_hist/${asset}/${assetType}/export/` : `/camo/ope_hist/${asset}/${assetType}/export/`, {
        ...queryParams,
    }).then((response) => {
        if (response.status === 500) {
            props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
        } else {
            this.setState({ pageLoader: false });
            downloadFileType(response.data, `${todayeDate}_ESN${basicDetails?.esn || basicDetails?.msn}_OpHistory`, queryParams.download);
            this.props.enqueueSnackbar("Download of Op. History List successful", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, });
            trackActivity("OP History Item Exported - CAMO", {
                page_title: "OP History Listing",
            });
        }
    });
}

export function deleteOpAttachment(id, props) {
    globalDeleteService(`camo/attachment/${id}/delete/`).then((response) => {
        if (response.status === 500) {
            props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
        } else {
            if (response) {
                props.enqueueSnackbar("Attachment Deleted Successfully", {
                    variant: "success",
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                });
            }
        }
    });
}

export function importOpFileApi(formData, props, isXLSX, per_page) {
    if (isXLSX) {
        this.setState({ pageLoader: true });
        const { asset, assetType } = this.props.match.params;

        globalFileUploadService(`camo/ope_hist/${asset}/${assetType}/import/`, formData)
            .then((response) => {
                this.setState({ pageLoader: false });
                if (response?.data?.statusCode === 200) {
                    trackActivity("OP History Import  Success - CAMO", {
                        event_type: 'Import  Success',
                        page_title: "OP History",
                        success_msg: response?.data?.message
                    });
                    props.enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, });
                } else {
                    trackActivity("OP History Import Failed - CAMO", {
                        event_type: 'Import  Failed',
                        page_title: "OP History",
                        error_msg: response?.data?.message
                    });
                    props.enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
                }
                this.getOpHistoryApi({ per_page: per_page }, "skeletonLoader", props);

            })
            .catch((err) => {
                console.error(err);
                props.enqueueSnackbar("Please import proper file", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
            });
    } else {
        props.enqueueSnackbar("Please Import only .XLSX File", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
    }
}

export function DownloadStSampleFile(queryParams = {}, loaderType, props = {},basicDetails) {
    const { asset, assetType } = props.match.params
    globalExportService(`camo/ope_hist/${asset}/${assetType}/sample/?download=xlsx`).then((response) => {
        if (response.status === 500) {
            props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
        } else {
            downloadFileType(response.data, `Sample_Op History_${basicDetails?.esn}`, queryParams.download);
            trackActivity("OP History Sample Download - CAMO", {
                page_title: "OP History Listing",
            });
        }
    });
}
export function getOperatorList() {
    globalGetService(`console/lessees/`).then((response) => {
        if (response.status === 200) {
            this.setState({ operatorList: response?.data?.data?.lessees })
        };
    })
};
export function allDropDownList() {
    this.setState({ pageLoader: true })
    globalGetService(`camo/all_dropdown_list/`)
      .then(response => {
        this.setState({ pageLoader: false })
        if (response?.status === 200) {
            this.setState({positionDropDownList:response.data.position_list})
        }
      })
  }
  export function getAllOppThrust(props,engine_type) {
    globalGetService(`camo/current_thrust/${props.assetType}/?engine_family_engine_type=${engine_type?.engine_family_type_id}`,)
      .then(response => {
        if (response?.status === 200) {
          this.setState({ operatingThrust: response?.data })
        }
      })
  }

  export function exportMasterApi(queryParams = {}, loaderType, props = {}) {
	this.setState({ pageLoader: true });
	const date = new Date();
	const todayeDate = moment(String(date)).format("DD-MM-YYYY");

	const { asset, assetType } = this.props.match.params;
	delete queryParams.asset_type;
	globalExportService(`/camo/smbc_master_excel/${asset}/${assetType}/export/`)
		.then((response) => {
			if (response.status === 500) {
				props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
			} else {
				this.setState({ pageLoader: false });
				downloadFileType(response.data, `Master_Export_${todayeDate}`, queryParams.download);
				this.props.enqueueSnackbar("Master Export Download Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, });
				trackActivity("Master Export", {
					page_title: "Asset Listing",
				});
			}
		});
}

export function bulkDelete(props, bulkOperation, per_page) {
    this.setState({ pageLoader: true });
    const { asset, assetType } = props?.match?.params;
    globalDeleteService(`camo/ope_hist/bulk_delete/${assetType}/${asset}/`, { delete_ids: bulkOperation.ids.map(optionItem => optionItem.id) }).then((response) => {
        if (response?.data?.statusCode === 200) {
            this.setState({ pageLoader: false });
            trackActivity("OP History Bulk Deleted Success - CAMO", {
                event_type:'Bulk Deleted',
                page_title: "OP History",
                success_msg:response?.data?.message
            });
            props.enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, });
        } else {
            props.enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
            trackActivity("OP History Bulk Deleted Failed - CAMO", {
                event_type: 'Bulk Deleted',
                page_title: "OP History",
                error_msg: response?.data?.message
            });
        }
        this.getOpHistoryApi({ per_page: per_page }, "skeletonLoader", props);
        this.setState({ bulkOperation: { modal: false, ids: [], title: '', type: '' } })
    });
}
export function onArchiveAsset(props,slug){
    globalGetService(`console/archive-asset/${assetType[props?.match?.params?.assetType]}/${slug}/true/`)
        .then(response => {
            if (checkApiStatus(response)) {
                props.enqueueSnackbar('Archive Status Updated Successfully', { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                props.history.push("/assets-listing")
            }else {
				props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
			}
        })
}

export async function DownloadAllApi(queryParams = {}, loaderType, props = {}) {
    this.setState({ pageLoader: true })
    const attachment_list = queryParams.item.download_attachments;
    for (var i = 0; i < attachment_list.length; i++) {
        var encodedURL = attachment_list[i][1];
        var decodedURL = decodeURIComponent(encodedURL);
        attachment_list[i][1] = decodedURL;
    }
    const zip = new JSZip();
    const folder = zip.folder('DownloadedFiles');
    try {
        const downloadPromises = attachment_list.map(async (entry) => {
            const name = entry[0];
            const url = entry[1] || '';

            const res = await fetch(url);

            if (!res.ok) {
                throw new Error(`HTTP error! Status: ${res.status}`);
            }

            const blob = await res.blob();
            folder.file(name, blob);
        });

        await Promise.all(downloadPromises);

        const content = await zip.generateAsync({ type: 'blob' });
        saveAs(content, 'Op. History Time.zip');
        this.setState({ pageLoader: false })
    } catch (error) {
        console.error('Error:', error);
    }
}

// export function getSvRemovalData(props, removalDate) {
//     debugger
//     const { asset, assetType } = props?.props?.match?.params;
//     globalGetService(`camo/shop_visit/details/?asset_id=${asset}&asset_type_id=${assetType}&removal_date=${removalDate}`,)
//         .then(response => {
//             if (checkApiStatus(response)) {
//                 debugger
//                 this.setState({ svRemovalData: response?.data })
//             }
//         })
// }





